import { render } from "./DS100AddressId.vue?vue&type=template&id=13c72888"
import script from "./DS100AddressId.vue?vue&type=script&lang=js"
export * from "./DS100AddressId.vue?vue&type=script&lang=js"

import "./DS100AddressId.vue?vue&type=style&index=0&id=13c72888&lang=css"

import exportComponent from "C:\\Users\\timdi\\Desktop\\funkapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__